document.addEventListener("DOMContentLoaded", () => {
  const MAX_BUNDLE_SIZE = 5;
  const selectedBundle = new Set();

  const buttons = document.querySelectorAll(".bundle-select-btn");

  function updateButtonState(button, selected) {
    const bag = button.querySelector(".bag-icon");
    const check = button.querySelector(".check-icon");

    if (bag && check) {
      bag.style.display = selected ? "none" : "inline-block";
      check.style.display = selected ? "inline-block" : "none";
    }

    button.classList.toggle("selected", selected);
  }

  function addBundleToCart() {
    const lineItems = Array.from(selectedBundle).map((variantId) => ({
      id: variantId,
      quantity: 1,
    }));

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ items: lineItems }),
    })
      .then((res) => res.json())
      .then(() => {
        window.location.href = "/cart";
      })
      .catch((err) => {
        console.error("Bundle add failed:", err);
      });
  }

  buttons.forEach((button) => {
    button.addEventListener("click", () => {
      const id = button.dataset.variantId;

      if (!id) return;

      const isSelected = selectedBundle.has(id);

      if (isSelected) {
        selectedBundle.delete(id);
        updateButtonState(button, false);
      } else if (selectedBundle.size < MAX_BUNDLE_SIZE) {
        selectedBundle.add(id);
        updateButtonState(button, true);

        if (selectedBundle.size === MAX_BUNDLE_SIZE) {
          addBundleToCart();
        }
      }
    });
  });
});
